export default "__VITE_ASSET__C1UP$S6C__"